<div class="eoi-modal-shell">

  <button class="eoi-close-btn" mat-icon-button (click)="onCancel()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  <!-- PHASE: FORM                                    -->
  <ng-container *ngIf="phase === 'form'">
    <!-- Header banner -->
    <div class="eoi-header">
      <div class="eoi-header-icon">
        <mat-icon>description</mat-icon>
      </div>
      <div>
        <h2 class="eoi-header-title">{{ messages.header.title }}</h2>
        <p class="eoi-header-sub">
          {{ messages.header.subtitle }}
        </p>
      </div>
    </div>

    <div class="eoi-body">
      <div class="eoi-info-strip">
        <mat-icon class="eoi-info-icon">info_outline</mat-icon>
        <span>
          {{ messages.info.description }}
        </span>
      </div>

      <app-formbuilder
        [steps]="steps"
        formName=""
        referenceNumber="EOI"
        [isPaymentRequired]="false"
        [columns]="formColumns"
        [isLoading]="isSubmitting"
        (submitForm)="onSubmitForm($event)"
      ></app-formbuilder>
    </div>
  </ng-container>

  <!-- PHASE: SUCCESS                                 -->
  <ng-container *ngIf="phase === 'success' && submittedData">
    <div class="eoi-success-wrap">

      <div class="eoi-success-icon-ring">
        <div class="eoi-success-icon-circle">
          <mat-icon>check</mat-icon>
        </div>
      </div>

      <h2 class="eoi-success-title">{{ messages.success.title }}</h2>
      <p class="eoi-success-lead">
        {{ messages.success.leadTextBefore }}
        <span class="eoi-status-badge">{{ messages.success.statusBadge }}</span>.
      </p>
      <p class="eoi-success-sub">
        An email will be sent to&nbsp;<strong>{{ submittedData.applicantEmail }}</strong>&nbsp;with
        a link to schedule your appointment once your EOI is approved.
      </p>

      <!-- Summary card -->
      <div class="eoi-summary-card">
        <div class="eoi-summary-row">
          <span class="eoi-summary-label">
            <mat-icon class="eoi-summary-icon">business</mat-icon>Company
          </span>
          <span class="eoi-summary-value">{{ submittedData.companyName }}</span>
        </div>
        <div class="eoi-summary-row">
          <span class="eoi-summary-label">
            <mat-icon class="eoi-summary-icon">tag</mat-icon>TIN
          </span>
          <span class="eoi-summary-value">{{ submittedData.tinNumber }}</span>
        </div>
        <div class="eoi-summary-row">
          <span class="eoi-summary-label">
            <mat-icon class="eoi-summary-icon">policy</mat-icon>Licence
          </span>
          <span class="eoi-summary-value">
            {{ submittedData.selectedLicense | removeUnderscore }}
          </span>
        </div>
        <div class="eoi-summary-row">
          <span class="eoi-summary-label">
            <mat-icon class="eoi-summary-icon">confirmation_number</mat-icon>Reference
          </span>
          <span class="eoi-summary-value eoi-ref">{{ submittedData.id }}</span>
        </div>
      </div>

      <button mat-flat-button class="eoi-done-btn" (click)="onDone()">
        <mat-icon>done_all</mat-icon>
        Done
      </button>
    </div>
  </ng-container>

</div>
